import moment from 'moment';

export default function teacherAvailable(teacher, records, plan, fallbackDate) {
  const id = String(teacher.id);
  if ((plan.absent || []).some((absentId) => String(absentId) === id)) return false;
  const current = records.find((record) => String(record.id) === id) || teacher;
  const date = moment(plan.daydate || fallbackDate);
  return !(current.absent || []).some((period) => Array.isArray(period.date)
    && date.isBetween(moment(period.date[0]), moment(period.date[1]), 'day', '[]'));
}
